import { useState, useEffect } from "react";

export type CopyButtonStateProp = { copyState: "initial" | "copied" | "error" };

const CopyButton = (props: React.ComponentPropsWithoutRef<"button"> & CopyButtonStateProp) => {
  const { copyState, ...elProps } = props;

  const [canCopy, setCanCopy] = useState(false);

  useEffect(() => {
    setCanCopy(
      typeof window != "undefined" && "clipboard" in navigator && "writeText" in navigator.clipboard
    );
  }, []);

  return canCopy && copyState !== "error" ? (
    <button className="absolute top-0 right-0" {...elProps}>
      {copyState === "copied" ? "✅" : "copy"}
    </button>
  ) : null;
};

export default CopyButton;
